<label [class.isInvalid]="getIsInvalid()">
  <vc-radio-input [name]="name" [value]="value"></vc-radio-input>

  <div class="label-text" *ngTemplateOutlet="labelTemplate || defaultLabelTemplate"></div>
</label>

<ng-template #defaultLabelTemplate let-item>
  {{ label }}
</ng-template>
